import axios from "../axiosInstance";
import { FetchStochasticCustomersRequest } from "./types";

export const fetchStochasticCustomersCsv = async (
  requestParams: FetchStochasticCustomersRequest = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(`/api/private/stochastic-customers`, {
    responseType: "blob",
    headers: {
      Accept: "text/csv",
    },
    params: {
      ...requestParams,
      format: "csv",
    },
  });

  return response.data;
};
